"use client";

import { QuestionMarkCircleIcon } from "@heroicons/react/24/solid";
import Tooltip from "@mui/material/Tooltip";
import { twMerge } from "tailwind-merge";

import { useLang } from "@/hooks/use-lang";
import { useUpdateQuery } from "@/hooks/use-update-query";

import {
  WhaleInterestFactorKey,
  getWhaleInterestFactors,
} from "../data/factors";

type Props = {
  symbol: string;
  currentFactor?: WhaleInterestFactorKey;
};

export const FactorSelect = ({
  symbol,
  currentFactor = "instOwnshp",
}: Props) => {
  const { t } = useLang();
  const options = getWhaleInterestFactors({ t, symbol });
  const { updateQuery } = useUpdateQuery();
  const currentOption = options.find(
    (option) => option.value === currentFactor
  );

  return (
    <div className="flex items-center gap-2.5 sm:hidden">
      <select
        className="block w-full max-w-[220px] rounded-md border-gray-300 focus:border-sky-600 focus:ring-sky-600"
        defaultValue={currentFactor}
        onChange={(e) => {
          updateQuery({
            name: "factor",
            value: e.target.value,
          });
        }}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <Tooltip
        enterTouchDelay={0}
        arrow={true}
        placement="top"
        title={currentOption?.tooltip ?? ""}
        slotProps={{
          tooltip: { className: "bg-zinc-900 text-white" },
          arrow: { className: "text-zinc-900" },
        }}
      >
        <QuestionMarkCircleIcon
          className={twMerge(
            "h-6 w-6",
            currentOption?.tooltip ? "text-sky-600" : "text-zinc-400"
          )}
        />
      </Tooltip>
    </div>
  );
};
